/**
 * Lupa UDV: no usa MagnifyTool de Cornerstone (segundo viewport + coords DPR).
 * Copia el canvas visible y posiciona con position:fixed.
 * Mouse y touch: la lupa se desplaza para no tapar el punto bajo el puntero/dedo.
 */

const LOUPE_CLASS = 'udv-magnify-loupe'
const POINTER_GAP = 28

export function ensureMagnifyLoupe() {
  if (typeof document === 'undefined') return null
  let el = document.getElementById(LOUPE_CLASS)
  if (el) return el
  el = document.createElement('canvas')
  el.id = LOUPE_CLASS
  el.setAttribute('aria-hidden', 'true')
  el.style.cssText = [
    'position:fixed',
    'display:none',
    'z-index:250000',
    'pointer-events:none',
    'border-radius:50%',
    'border:2px solid #64B5F6',
    'box-shadow:0 0 0 1px #000, 0 8px 20px rgba(0,0,0,0.55)',
    'background:#111',
  ].join(';')
  document.body.appendChild(el)
  return el
}

export function hideMagnifyLoupe() {
  const el = typeof document !== 'undefined' && document.getElementById(LOUPE_CLASS)
  if (el) el.style.display = 'none'
}

export function destroyMagnifyLoupe() {
  const el = typeof document !== 'undefined' && document.getElementById(LOUPE_CLASS)
  if (el && el.parentNode) el.parentNode.removeChild(el)
}

function loupeScreenPos(clientX, clientY, size) {
  const vw = typeof window !== 'undefined' ? window.innerWidth : size
  const vh = typeof window !== 'undefined' ? window.innerHeight : size
  let left = clientX - size / 2
  let top = clientY - size - POINTER_GAP
  if (top < 8) {
    top = clientY + POINTER_GAP
  }
  if (top + size > vh - 8) {
    top = Math.max(8, vh - size - 8)
  }
  if (left < 8) left = 8
  if (left + size > vw - 8) left = Math.max(8, vw - size - 8)
  return { left, top }
}

/**
 * @param {HTMLElement} viewerEl
 * @param {number} clientX
 * @param {number} clientY
 * @param {{ size?: number, mag?: number, pointerType?: string }} [opts]
 */
export function paintMagnifyLoupe(viewerEl, clientX, clientY, opts = {}) {
  const loupe = ensureMagnifyLoupe()
  if (!loupe || !viewerEl) return

  const source =
    viewerEl.querySelector('canvas.cornerstone-canvas') ||
    viewerEl.querySelector('canvas:not(.udv-magnify-loupe):not(.magnifyTool)')
  if (!source || !source.width || !source.height) return

  const pointerType = opts.pointerType || 'mouse'
  const isTouch = pointerType === 'touch' || pointerType === 'pen'
  const compact =
    typeof window !== 'undefined' &&
    (isTouch || window.innerWidth < 1024)
  const size = opts.size || (compact ? 160 : 220)
  const mag = opts.mag || 2.5

  const srcRect = source.getBoundingClientRect()
  if (!(srcRect.width > 0) || !(srcRect.height > 0)) return

  const scaleX = source.width / srcRect.width
  const scaleY = source.height / srcRect.height
  const cx = (clientX - srcRect.left) * scaleX
  const cy = (clientY - srcRect.top) * scaleY
  const sw = (size / mag) * scaleX
  const sh = (size / mag) * scaleY

  if (loupe.width !== size || loupe.height !== size) {
    loupe.width = size
    loupe.height = size
  }

  const ctx = loupe.getContext('2d')
  ctx.imageSmoothingEnabled = true
  ctx.fillStyle = '#111'
  ctx.fillRect(0, 0, size, size)
  ctx.drawImage(source, cx - sw / 2, cy - sh / 2, sw, sh, 0, 0, size, size)

  const pos = loupeScreenPos(clientX, clientY, size)
  loupe.style.width = `${size}px`
  loupe.style.height = `${size}px`
  loupe.style.left = `${Math.round(pos.left)}px`
  loupe.style.top = `${Math.round(pos.top)}px`
  loupe.style.display = 'block'
}
